import { render, staticRenderFns } from "./LoanDetailsModal.vue?vue&type=template&id=47abfc58&scoped=true"
import script from "./LoanDetailsModal.vue?vue&type=script&lang=js"
export * from "./LoanDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./LoanDetailsModal.vue?vue&type=style&index=0&id=47abfc58&lang=css"
import style1 from "./LoanDetailsModal.vue?vue&type=style&index=1&id=47abfc58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abfc58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47abfc58')) {
      api.createRecord('47abfc58', component.options)
    } else {
      api.reload('47abfc58', component.options)
    }
    module.hot.accept("./LoanDetailsModal.vue?vue&type=template&id=47abfc58&scoped=true", function () {
      api.rerender('47abfc58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Modal/LoanDetailsModal.vue"
export default component.exports